import { months } from '@/models/months'

export const currency = (value) => {
  const [rest, cents] = value.split('.')
  const currency = `R$ ${rest},${cents}`

  return currency
}

export const subscriptionCurrency = (value) => {
  return `R$ ${value},00`
}

export const subscriptionDate = (value) => {
  if (!value) return ''
  const date = value.substring(0, 10)
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

export const subscriptionAcquireDate = (value) => {
  if (!value) return ''
  const date = value.substring(0, 10)
  const [year, month] = date.split('-')
  const monthNumber = parseFloat(month)
  return months[monthNumber] + ' de ' + year
}

export const subscriptionDateTime = (value) => {
  if (!value) return ''
  const date = new Date(value)
  if (isNaN(date)) return ''
  const pad = (number) => String(number).padStart(2, '0')
  return `${pad(date.getDate())}/${pad(
    date.getMonth() + 1
  )}/${date.getFullYear()} - ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export const subscriptionExpireCardDate = (value) => {
  const date1 = value.substring(0, 2)
  const date2 = value.substring(2, 4)
  return date1 + '/' + date2
}

export function titleCase(title) {
  if (!title) return ''
  return title[0].toUpperCase() + title.substring(1)
}

export function limitText(text, limit = 36) {
  if (text.length >= limit) {
    return text.substring(0, limit) + '...'
  }
  return text
}

export function fileName(name) {
  const [, , , , fileName] = name.split('/')
  return limitText(fileName)
}

export function showFirstName(name) {
  const [firstName] = name.split(' ')
  return firstName
}
